import BookingDiaryShopComponentHtml from './booking-diary.shop.html';

export const BookingDiaryShopComponent : ng.IComponentOptions = {
  bindings: {
    event: '='
  },
  controller : 'BookingDiaryShopCtrl',
  templateUrl: BookingDiaryShopComponentHtml
};
